import { SERVICE_URL } from './ServiceURL'

class ContactService {

	constructor(resource) {
		this.store = resource.$store;
		this.http = resource.$http;
  }

  fetchOneContact() {
		return new Promise((resolve, reject) => {
			this.http.get(`${SERVICE_URL}v1/contact/next`, {
					headers: {
						'x-access-token': this.store.state.user.token || ''
					}
        })
				.then(response => response.json())
				.then(contact => resolve(contact))
				.catch(err => {
					console.log(err);
					reject(err.body.message || err.message);
				})
		});
  }

	fetch(phone) {
		return new Promise((resolve, reject) => {
			this.http.get(`${SERVICE_URL}v1/contact/phone/${phone}`, {
					headers: {
						'x-access-token': this.store.state.user.token || ''
					}
				})
				.then(response => response.json())
				.then(contact => resolve(contact))
				.catch(err => {
					console.log(err);
					reject(err.body.message || err.message);
				})
		});
	}

	get(id) {
		return new Promise((resolve, reject) => {
			this.http.get(`${SERVICE_URL}v1/contact/${id}`, {
					headers: {
						'x-access-token': this.store.state.user.token || ''
					}
				})
				.then(response => response.json())
				.then(contact => resolve(contact))
				.catch(err => {
					console.log(err)
					reject(err.body || err.message || err);
				})
		});
	}

	addTelefone(contactId, telefone) {
		let data = {
			idContato: contactId,
			tel: telefone
		}
		return new Promise((resolve, reject) => {
			this.http.post(`${SERVICE_URL}v1/contact/phone/add`, data, {
					headers: {
						'x-access-token': this.store.state.user.token || ''
					}
				})
				.then(response => response.json())
				.then(result => resolve(result))
				.catch(err => {
					console.log("reject")
					reject(new Error(err.message || err));
				});
		});
	}

	finish(data) {
		return new Promise((resolve, reject) => {
			this.http.post(`${SERVICE_URL}v1/contact/${data.id}`, data, {
          timeout: 10 * 1100,
					headers: {
						'x-access-token': this.store.state.user.token || ''
					}
				})
				.then(response => response.json())
				.then(result => resolve())
				.catch(err => {
					console.log("reject")
					reject(err.message || err);
				});
		});
	}
}
export default ContactService;



// WEBPACK FOOTER //
// ./src/service/ContactService.js